import Vue from 'vue'
import Vuex from 'vuex'
import history from './history'
import userStore from './userStore'
// import * as M from '../constant/mutation-types'

Vue.use(Vuex)
const store = new Vuex.Store({
  plugins: [
    history({
      paths: []
    })
  ],
  modules: {
    userStore
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js